import AllSignals from "@/views/signal/AllSignals";

export default { AllSignals };
